import TPWBYTImage from '../../assets/albums/covers/tpwbyt.jpg';
import VinylAlbum from './VinylAlbum';

function ThisPlaceWillBecomeYourTomb({ albumRef, delay, onClick, isPlaying }) {
  return (
    <VinylAlbum
      image={TPWBYTImage}
      alt="This Place Will Become Your Tomb"
      isPlaying={isPlaying}
      onClick={onClick}
      albumRef={albumRef}
      delay={delay}
    />
  );
}

export default ThisPlaceWillBecomeYourTomb;